import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SavedView } from '../interfaces/saved-view';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class SavedViewsService {
  url = AppConfigService.settings.apiUrl + 'SavedViews/';
  constructor(private http: HttpClient) {}

  getSavedViews() {
    return this.http.get(this.url);
  }
  getSavedView(id: number) {
    return this.http.get(this.url + id);
  }
  postSavedView(view: SavedView): Observable<SavedView> {
    return this.http.post<SavedView>(this.url, view);
  }
  putSavedView(view: SavedView, id: number) {
    return this.http.put(this.url + id, view);
  }
  deleteSavedView(id: number) {
    return this.http.delete(this.url + id);
  }

  saveDefaultView(view: SavedView) {
    return this.http.post(`${this.url}SaveUserDefaultView`, view);
  }
  getUserDefaultView() {
    return this.http.get(`${this.url}UserDefaultView`);
  }
}
